import http from '@/apis';
import { LoginRequestDto } from '@/dto/users/LoginRequest.dto';
import { ResetPassword } from '@/dto/users/ResetPassword.dto';
import { ChangeEmail } from '@/dto/users/ChangeEmail.dto';
import { ChangePassword } from '@/dto/users/ChangePassword.dto';
import CreateUserDto from '@/dto/users/CreateUser.dto';

class AuthenticateService {
  prefix = 'api/users';

  public async validateToken(token: string) {
    const result = await http.post(`${this.prefix}/check-token`, { token });
    return result.data.result;
  }

  public async login(model: LoginRequestDto) {
    const result = await http.post(`${this.prefix}/login`, model);
    return result.data.result;
  }

  public async register(model: CreateUserDto) {
    const result = await http.post(`${this.prefix}`, model);
    return result.data.result;
  }

  public async verifyEmail(token: string) {
    const result = await http.post(`${this.prefix}/verify-email`, {
      token,
    });

    return result.data.result;
  }

  public async verifyChangeEmail(token: string) {
    const result = await http.post(`${this.prefix}/verify-change-email`, {
      token,
    });

    return result.data.result;
  }

  public async confirmChangeEmail(token: string) {
    const result = await http.post(`${this.prefix}/confirm-change-email`, {
      token,
    });

    return result.data.result;
  }

  public async forgotPassword(email: string) {
    const result = await http.post(`${this.prefix}/forgot-password`, { email });
    return result.data.result;
  }

  public async resetPassword(model: ResetPassword) {
    const result = await http.post(`${this.prefix}/reset-password`, model);
    return result.data.result;
  }

  public async changePassword(model: ChangePassword) {
    const result = await http.post(`${this.prefix}/change-password`, model);
    return result.data.result;
  }

  public async changeEmail(model: ChangeEmail) {
    const result = await http.post(`${this.prefix}/change-email`, model);
    return result.data.result;
  }
}

export default new AuthenticateService();
